<template>
  <div class="home">

    <!-- ── Hero ── -->
    <section class="hero">
      <div class="hero__inner">
        <div class="hero__logo-wrap">
          <img class="hero__logo" src="@/assets/inverted_transparent_logo_small.png" alt="Prime Mover Electrical logo" />
        </div>
        <div class="hero__text">
          <h1 class="hero__title">Prime Mover Electrical Inc.</h1>
          <p class="hero__subtitle">Yarmouth NS</p>
        </div>
      </div>
      <div class="hero__glow"></div>
    </section>

    <!-- ── Photo Slider ── -->
    <div class="slider-outer">
      <div class="slider-wrap">
        <slider ref="slider" :options="options" @slide="slide" @tap="onTap" @init="onInit">
          <slideritem v-for="(item, index) in someList" :key="index" :style="item.style">
            <img :src="getImgUrl(item)" class="slide-img" />
        </slideritem>
          <div slot="loading" class="slide-loading">loading...</div>
        </slider>
      </div>
    </div>

    <!-- ── Info Section ── -->
    <div class="info-section" :class="{ 'info-visible': infoVisible }" ref="infoSection">
      <div class="info-card">

        <!-- Description paragraphs -->
        <div class="info-block info-block--text">
          <p class="info-para">We provide electrical services to the Tri-Counties.</p>
          <p class="info-para">
            Byron is a <a href="https://www.nsapprenticeship.ca/tradespersons/trade-certificates" target="new" class="accent-link">Red Seal</a> electrician with 11 years of experience in the trade and 22 years experience in various trades.
          </p>
          <p class="info-para">
            Types of electrical work include residential, commercial, and heat pump installation. We sell <strong>Tempstar Heat Pumps</strong> with a 10 year warranty.
          </p>
        </div>

        <div class="info-divider"></div>

        <!-- Contact CTAs -->
        <div class="info-block info-block--contact">
          <a href="tel:902-740-9104" class="cta-btn cta-btn--phone" id="cta-phone-1">
            <i class="fas fa-phone"></i>
            <span>902-740-9104</span>
          </a>
          <a href="tel:902-307-2614" class="cta-btn cta-btn--phone" id="cta-phone-2">
            <i class="fas fa-phone"></i>
            <span>902-307-2614</span>
          </a>
          <a href="mailto:contact@pmelectrical.ca" class="cta-btn cta-btn--email" id="cta-email">
            <i class="fas fa-envelope"></i>
            <span>contact@pmelectrical.ca</span>
          </a>
        </div>

        <div class="info-divider"></div>

        <!-- Extras -->
        <div class="info-block info-block--extras">
          <span class="badge" id="badge-french">
            <i class="fas fa-comment"></i> nous parlons francais
          </span>
          <a href="https://g.page/r/Cc2jIKKOSJuEEAI/review" target="new" class="cta-btn cta-btn--reviews" id="cta-reviews">
            <i class="fas fa-star"></i>
            <span>Click here for reviews!</span>
          </a>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { slider, slideritem } from 'vue-concise-slider'

export default {
  name: 'HomeView',
  data () {
    return {
      publicPath: process.env.BASE_URL,
      someList: [],
      infoVisible: false,
      options: {
        currentPage: 0,
        thresholdDistance: 500,
        thresholdTime: 100,
        autoplay: 2500,
        loop: true,
        direction: 'horizontal',
        loopedSlides: 1,
        slidesToScroll: 1,
        timingFunction: 'ease',
        speed: 1500
      }
    }
  },
  components: {
    slider,
    slideritem
  },
  methods: {
    getImgUrl (item) {
      return require('../assets/photos/' + item.image)
    },
    slide (data) {
      console.log(data)
    },
    onTap (data) {
      console.log(data)
    },
    onInit (data) {
      console.log(data)
    }
  },
  mounted () {
    setTimeout(() => {
      this.someList = [
        { image: 'photo1.png', style: { background: '#111' } },
        { image: 'photo2.png', style: { background: '#111' } },
        { image: 'photo3.png', style: { background: '#111' } },
        { image: 'photo4.png', style: { background: '#111' } },
        { image: 'photo5.png', style: { background: '#111' } }
      ]
    }, 200)

    // Intersection Observer for fade-in animation
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.infoVisible = true
          observer.disconnect()
        }
      },
      { threshold: 0.1 }
    )
    this.$nextTick(() => {
      if (this.$refs.infoSection) {
        observer.observe(this.$refs.infoSection)
      }
    })
  }
}
</script>

<style scoped>
/* ── Hero ── */
.hero {
  position: relative;
  background: linear-gradient(135deg, #0a0a0a 0%, #111 50%, #0f0f0f 100%);
  border-bottom: 1px solid rgba(255, 214, 0, 0.12);
  overflow: hidden;
  padding: 2.5rem 1.5rem;
}

.hero__glow {
  position: absolute;
  top: -60px;
  left: -60px;
  width: 320px;
  height: 320px;
  background: radial-gradient(circle, rgba(255, 214, 0, 0.06) 0%, transparent 70%);
  pointer-events: none;
}

.hero__inner {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 2rem;
}

.hero__logo-wrap {
  flex-shrink: 0;
}

.hero__logo {
  height: 90px;
  width: auto;
  object-fit: contain;
  filter: drop-shadow(0 0 18px rgba(255, 214, 0, 0.25));
}

.hero__text {
  flex: 1;
}

.hero__title {
  font-size: clamp(1.5rem, 3.5vw, 2.4rem);
  font-weight: 800;
  color: #ffffff;
  letter-spacing: -0.02em;
  line-height: 1.15;
  margin-bottom: 0.4rem;
}

.hero__subtitle {
  font-size: clamp(0.9rem, 2vw, 1.1rem);
  font-weight: 500;
  color: #FFD600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

/* ── Slider ── */
.slider-outer {
  background: #0d0d0d;
  padding: 1.5rem 0;
}

.slider-wrap {
  max-width: 900px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);
}

.slide-img {
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 420px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}

.slide-loading {
  color: #666;
  font-size: 0.9rem;
  padding: 2rem;
}

/* ── Info Section ── */
.info-section {
  padding: 3rem 1.5rem 4rem;
  max-width: 860px;
  margin: 0 auto;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.7s ease, transform 0.7s ease;
}

.info-section.info-visible {
  opacity: 1;
  transform: translateY(0);
}

.info-card {
  background: #161616;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  padding: 2.5rem 2rem;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);
}

.info-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
  margin: 1.75rem 0;
}

/* Text block */
.info-block--text {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.info-para {
  font-size: clamp(0.95rem, 2.2vw, 1.05rem);
  line-height: 1.7;
  color: #d0d0d0;
}

.accent-link {
  color: #FFD600;
  font-weight: 600;
  border-bottom: 1px solid rgba(255, 214, 0, 0.35);
}
.accent-link:hover {
  color: #ffe94d;
  border-bottom-color: #ffe94d;
}

/* Contact CTAs */
.info-block--contact {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.65rem 1.2rem;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  text-decoration: none;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
  min-height: 48px;
}

.cta-btn--phone {
  background: rgba(255, 214, 0, 0.1);
  color: #FFD600;
  border: 1px solid rgba(255, 214, 0, 0.25);
}
.cta-btn--phone:hover {
  background: rgba(255, 214, 0, 0.18);
  color: #FFD600;
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(255, 214, 0, 0.15);
  opacity: 1;
}

.cta-btn--email {
  background: rgba(100, 180, 255, 0.08);
  color: #7ec8ff;
  border: 1px solid rgba(100, 180, 255, 0.2);
}
.cta-btn--email:hover {
  background: rgba(100, 180, 255, 0.15);
  color: #7ec8ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(100, 180, 255, 0.12);
  opacity: 1;
}

/* Extras */
.info-block--extras {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #bbb;
  font-size: 0.85rem;
  font-style: italic;
  padding: 0.4rem 0.85rem;
  border-radius: 999px;
}

.cta-btn--reviews {
  background: linear-gradient(135deg, rgba(255, 180, 0, 0.15), rgba(255, 214, 0, 0.08));
  color: #FFD600;
  border: 1px solid rgba(255, 214, 0, 0.3);
  font-size: 0.95rem;
}
.cta-btn--reviews:hover {
  background: linear-gradient(135deg, rgba(255, 180, 0, 0.25), rgba(255, 214, 0, 0.15));
  color: #FFD600;
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(255, 214, 0, 0.2);
  opacity: 1;
}

/* ── Mobile ── */
@media (max-width: 600px) {
  .hero__inner {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 1.25rem;
  }

  .hero__logo {
    height: 70px;
  }

  .slide-img {
    max-height: 55vw;
    min-height: 160px;
  }

  .info-card {
    padding: 1.75rem 1.25rem;
  }

  .info-block--contact {
    flex-direction: column;
  }

  .cta-btn {
    width: 100%;
    justify-content: center;
  }

  .info-block--extras {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
